import type { Directive } from "vue";

/**
 * Директива v-click-outside
 *
 * Вызывает callback-функцию при клике вне элемента
 *
 * Использование:
 * <div v-click-outside="handleClickOutside">...</div>
 */

const handlers = new WeakMap<HTMLElement, (event: MouseEvent) => void>();

export const vClickOutside: Directive<HTMLElement, (event: MouseEvent) => void> = {
  mounted(el, binding) {
    // Создаем обработчик клика
    const clickHandler = (event: MouseEvent) => {
      // Проверяем, что клик был вне элемента и его потомков
      if (!(el === event.target || el.contains(event.target as Node))) {
        // Вызываем callback, переданный в директиву
        binding.value(event);
      }
    };

    // Сохраняем обработчик
    handlers.set(el, clickHandler);

    // Добавляем обработчик на следующем тике, чтобы избежать срабатывания
    // при том же клике, который открыл меню
    setTimeout(() => {
      document.addEventListener("click", clickHandler);
    }, 0);
  },

  unmounted(el) {
    // Получаем обработчик
    const clickHandler = handlers.get(el);

    if (clickHandler) {
      // Удаляем обработчик события
      document.removeEventListener("click", clickHandler);

      // Удаляем обработчик
      handlers.delete(el);
    }
  }
};